import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsSetterDirective } from 'src/business/models/general-element-settings';

@Component({
    selector: 'app-calendly-element',
    templateUrl: './calendly-element.component.html',
    styleUrl: './calendly-element.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendlyElementComponent extends SettingsSetterDirective {
    url: string;
}
